module.exports = __webpack_public_path__ + "media/images/bg-paper-5458f3198b4ac2a5c6b5028dab57328f.png";